import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import { FaDownload, FaReceipt, FaFileInvoiceDollar } from "react-icons/fa";
import { withRouter } from "react-router";
import MiniLoader from "./MiniLoader";
import * as actions from "../redux/actions/ordersActions";
import {
  formatOrderTotal,
  formatReceiptNumber,
  getOrderStatusClass,
} from "../assets/orderUtils";
import "./styles/OrderList.css";

class PayListItem extends React.Component {
  render() {
    const { item, onClick } = this.props;
    const receiptNumber = formatReceiptNumber(item);

    return (
      <article className="order-card">
        <div className="order-card__icon" aria-hidden="true">
          <FaFileInvoiceDollar />
        </div>

        <div className="order-card__body">
          <div className="order-card__header">
            <div className="order-card__title-block">
              <span className="order-card__eyebrow">
                <Translate value="order_receipt_official" />
              </span>
              <h3 className="order-card__title">{receiptNumber}</h3>
            </div>
            <span className={`order-card__status ${getOrderStatusClass(item.Status)}`}>
              {item.Status}
            </span>
          </div>

          <dl className="order-card__meta">
            <div className="order-card__meta-row">
              <dt>
                <Translate value="order_receipt_number" />
              </dt>
              <dd className="order-card__receipt-seq">{receiptNumber}</dd>
            </div>
            <div className="order-card__meta-row">
              <dt>
                <Translate value="order_kind" />
              </dt>
              <dd>{item.Kind}</dd>
            </div>
            <div className="order-card__meta-row">
              <dt>
                <Translate value="order_date" />
              </dt>
              <dd>{item.CreatedAt}</dd>
            </div>
            <div className="order-card__meta-row order-card__meta-row--total">
              <dt>
                <Translate value="order_total" />
              </dt>
              <dd>{formatOrderTotal(item.Total)}</dd>
            </div>
          </dl>
        </div>

        <div className="order-card__actions">
          <button
            type="button"
            className="order-card__action"
            onClick={onClick}
            aria-label={I18n.t("order_view_receipt")}
          >
            <FaDownload />
            <span>
              <Translate value="order_view_receipt" />
            </span>
          </button>
        </div>
      </article>
    );
  }
}

class PayList extends React.Component {
  onClickLoadMore = () => {
    this.fetchOrdersList();
  };

  fetchOrdersList = async () => {
    try {
      await this.props
        .LoadOrders(this.props.pageCount, this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alert(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClick = (item) => {
    const win = window.open("/orderview/" + item.Id, "_blank");
    if (win) win.focus();
  };

  render() {
    if (!this.props.orderList.length) {
      return (
        <div className="order-list__empty">
          <div className="order-list__empty-icon" aria-hidden="true">
            <FaReceipt />
          </div>
          <h3 className="order-list__empty-title">
            <Translate value="order_empty_title" />
          </h3>
          <p>
            <Translate value="order_not_list" />
          </p>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="order-list__summary">
          <span className="order-list__summary-label">
            <Translate value="order_receipt_count" />
          </span>
          <strong>{this.props.total || this.props.orderList.length}</strong>
        </div>

        <div className="order-list">
          {this.props.orderList.map((item) => (
            <PayListItem
              item={item}
              key={item.Id}
              onClick={() => {
                this.onClick(item);
              }}
            />
          ))}
        </div>

        {this.props.pageSize >= 7 &&
          (this.props.loadingMore ? (
            <div className="order-list__load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="order-list__load-more">
              <button
                type="button"
                className="order-list__load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    orderList: reducer.orders.list,
    error: reducer.orders.error,
    pageCount: reducer.orders.page_count,
    pageSize: reducer.orders.page_size,
    total: reducer.orders.total,
    loadingMore: reducer.orders.loadingMore,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadOrders: (page_index, user_id, token) =>
    dispatch(actions.loadListScroll({ page_index, user_id, token })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PayList));
